// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".impact-table .v-icon[data-v-a00cd29e]  svg{height:16px!important;width:16px!important}", ""]);
// Exports
module.exports = exports;
